import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-grid-system';
import classNames from 'classnames/bind';
import Section from '../Section';
import Timer from '../Timer';
import { getLinkTag } from '../../utils';

import styles from './announcement.module.scss';

const cx = classNames.bind(styles);

function Announcement(props) {
  const {
    countdown,
    positionFixed,
    title,
    url,
  } = props;

  const linkInformation = getLinkTag(url);
  const Tag = linkInformation.tag || 'div';
  const tagProps = linkInformation.tagProps || {};

  const announcementClassName = cx({
    announcement: true,
    withCountdown: countdown,
    fixed: !!positionFixed,
  });

  const announcementContent = (
    <div className={announcementClassName}>
      <Section size="small">
        <Col>
          <div className={styles.wrapper}>
            <div className={styles.title} data-test="announcement-title">
              {title}
            </div>

            {countdown && (
              <Timer {...props} modifierclass={styles.countdown} />
            )}
          </div>
        </Col>
      </Section>
    </div>
  );

  return (
    <>
      {(url
        ? (
          <Tag {...tagProps} className={styles.link}>
            {announcementContent}
          </Tag>
        )
        : announcementContent
      )}
    </>
  );
}

export default Announcement;

Announcement.propTypes = {
  countdown: PropTypes.objectOf(PropTypes.string),
  positionFixed: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
};

Announcement.defaultProps = {
  countdown: null,
  positionFixed: false,
  url: '',
};
